type SkeletonVariant = 'card' | 'kpi' | 'row' | 'chart' | 'text';

interface SkeletonProps {
  variant?: SkeletonVariant;
  className?: string;
}

const BASE = 'animate-pulse rounded-gn bg-gn-border/60';

export function Skeleton({ variant = 'text', className = '' }: SkeletonProps) {
  const sizeClass = {
    card: 'h-32 w-full',
    kpi: 'h-24 w-full',
    row: 'h-12 w-full',
    chart: 'h-64 w-full',
    text: 'h-4 w-full',
  }[variant];
  return <div className={`${BASE} ${sizeClass} ${className}`.trim()} aria-hidden="true" />;
}

interface SkeletonGridProps {
  count: number;
  variant: SkeletonVariant;
  className?: string;
}

export function SkeletonGrid({ count, variant, className = '' }: SkeletonGridProps) {
  return (
    <div className={`grid gap-4 ${className}`.trim()}>
      {Array.from({ length: count }).map((_, i) => (
        <Skeleton key={i} variant={variant} />
      ))}
    </div>
  );
}
